import { atom, createStore } from 'jotai';
export const navigationStore = createStore();
const defaultNavigationState = {
    navigationTime: 0,
    isAjaxNavigation: false,
    pathname: undefined,
};
export const navigationAtom = atom(defaultNavigationState);
export const trackNavigation = (state) => {
    const storedPath = navigationStore.get(navigationAtom).pathname;
    if (storedPath === state.location.pathname) {
        return;
    }
    if (storedPath === undefined) {
        navigationStore.set(navigationAtom, {
            ...defaultNavigationState,
            pathname: state.location.pathname,
        });
        return;
    }
    navigationStore.set(navigationAtom, {
        navigationTime: performance.now(),
        isAjaxNavigation: true,
        pathname: state.location.pathname,
    });
};
//# sourceMappingURL=navigation_state.preenvesnextjs.map
